import { TableActionButtonDelete } from '@core/components/TableAction';
import { formatCNPJ, formatCPF } from '@format';
import {
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles({
  cellCliente: {
    padding: '6px 0px 6px 16px',
  },
});

const CadastroGrupoClienteTable = ({ clientes, onRemove }) => {
  const styles = useStyles();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Typography style={{ marginRight: 16, fontSize: 18, textTransform: 'initial' }} variant="button">
          Lista de clientes
        </Typography>
        <Divider />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ paddingBottom: 0 }} className="mb-16">
        <Table size="small" className={styles.table}>
          <TableHead>
            <TableRow>
              <TableCell align="left" className={styles.cellCliente}>
                Nome do cliente
              </TableCell>
              <TableCell align="center">CNPJ / CPF</TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {clientes?.map((cliente) => {
              return (
                <TableRow key={cliente?.pessoa ? cliente?.pessoa?.nome : cliente?.nome}>
                  <TableCell component="th" align="left">
                    {cliente?.pessoa ? cliente?.pessoa?.nome : cliente?.nome}
                  </TableCell>
                  <TableCell align="center">
                    {cliente?.pessoa?.pessoaJuridica
                      ? formatCNPJ(cliente?.pessoa?.pessoaJuridica?.cnpj)
                      : formatCNPJ(cliente?.cnpj)}
                    {cliente?.pessoa?.pessoaFisica
                      ? formatCPF(cliente?.pessoa?.pessoaFisica?.cpf)
                      : formatCPF(cliente?.cpf)}
                  </TableCell>
                  <TableCell align="right">
                    <TableActionButtonDelete className={'stepIconeExcluir'} onClick={() => onRemove(cliente)} />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
};
export default CadastroGrupoClienteTable;
